// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3udPn","disabled":"FileBtn_disabled__2k217","warn":"FileBtn_warn__1ba9R","fade":"FileBtn_fade__2L205"};